const ApiWidgetType = {
  OVERVIEW: 'ihs-overview',
  PREVIOUS_MEETINGS: 'ihs-previous-meetings',
  VICTORY_PROBABILITY: 'ihs-victory-probability',
  LAST_5_GAMES: 'ihs-last-5-games',
  TOP_SCORERS: 'ihs-top-scorers',
  SEASON_STATS: 'ihs-season-stats',
  GOALS: 'ihs-goals',
  OVER_GOALS: 'ihs-over-goals',
  SHOTS: 'ihs-shots',
  AVERAGE_MATCH_STATS: 'ihs-avg-match-stats',
  VENUE_REFEREE: 'ihs-venue-referee',
  POPULAR_ODDS: 'popular-odds',
  LAST_5_GAMES_COMPACT: 'ihs-last-5-games-compact',
  LEAGUE_TABLE: 'ihs-league-table',
  PLAYER_STATS: 'ihs-player-stats',
  LINEUP: 'ihs-line-up',
  MATCH_ROW_UPCOMING: 'match-row-upcoming',
  MATCH_ROW_FINISHED: 'match-row-finished',
} as const;

export default ApiWidgetType;
